import { useState } from "react";
import { Button, TextField } from "@mui/material";

export interface SnippetPreviewProps {
    integrationId: string;
    scriptUrl: string;
}

/**
 * Renders the `<script>` tag a customer pastes onto their site. The URL is
 * supplied by the backend (`integration.scriptUrl`) so the per-environment
 * `chat.<host>` resolution stays server-side.
 */
export default function SnippetPreview({ integrationId, scriptUrl }: SnippetPreviewProps) {
    const [copied, setCopied] = useState(false);

    const snippet = `<script\n  src="${scriptUrl}"\n  data-integration-id="${integrationId}"\n  async\n></script>`;

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(snippet);
            setCopied(true);
            window.setTimeout(() => setCopied(false), 1500);
        } catch {
            /* clipboard may be unavailable (insecure context); ignore */
        }
    };

    return (
        <div className="integration-snippet-preview">
            <div className="integration-snippet-preview__header">
                <span className="integration-snippet-preview__title">Embed snippet</span>
                <Button
                    size="small"
                    variant="contained"
                    onClick={handleCopy}
                    aria-label="Copy embed snippet"
                >
                    {copied ? "Copied" : "Copy"}
                </Button>
            </div>
            <TextField
                multiline
                fullWidth
                value={snippet}
                minRows={5}
                InputProps={{ readOnly: true }}
                inputProps={{ style: { fontFamily: "monospace", fontSize: 12 } }}
            />
        </div>
    );
}
